import {
  faMapMarker,
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

export const contactDetails = [
  {
    id: 1,
    icon: faMapMarker,
    title: "Address",
    content:
      "Near 5 No.Bus Stop, Main Ferozpur Road, Kahna Nau, Lahore, Pakistan",
  },
  {
    id: 2,
    icon: faPhone,
    title: "Phone",
    content: "0300-4516820",
  },
  {
    id: 3,
    icon: faEnvelope,
    title: "Email",
    content: "ch_imtiazali@yahoo.com",
  },
  {
    id: 4,
    icon: faClock,
    title: "Hours",
    content: "Mon - Sun : 09 AM - 09 PM",
  },
];

export const gallery = [
  {
    id: 1,
    link: "images/gallery1.jpg",
    alt: "gallery1",
  },
  {
    id: 2,
    link: "images/gallery2.jpg",
    alt: "gallery2",
  },
  {
    id: 3,
    link: "images/gallery3.jpg",
    alt: "gallery3",
  },
  {
    id: 4,
    link: "images/gallery4.jpg",
    alt: "gallery4",
  },
  {
    id: 5,
    link: "images/gallery5.jpg",
    alt: "gallery5",
  },
  {
    id: 6,
    link: "images/gallery6.jpg",
    alt: "gallery6",
  },
];